import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from '../button';

const ConfirmResendModal = ({
  show,
  onHide,
  onConfirm,
  orderNo,
  email
}) => {
  return (
    <Modal show={show} onHide={onHide} centered className="confirm-modal">
      <Modal.Header className="modal-header-custom">
        <Modal.Title className="modal-title-custom">Resend Confirmation</Modal.Title>
      </Modal.Header>
      <Modal.Body className="modal-body-custom">
        <p className="instruction-text">
          Are you sure you want to resend order <strong>{orderNo}</strong> notification to <strong>{email}</strong>?
        </p>
      </Modal.Body>
      <Modal.Footer className="modal-footer-custom">
        <Button
          style={{
            backgroundColor: '#ED1A3D',
            color: 'white',
            height: '40px',
            borderRadius: '10px',
            border: 'none',
            cursor: 'pointer',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '10px 20px',
            marginRight: '10px'
          }}
          onClick={onConfirm}
        >
          CONFIRM RESEND
        </Button>
        <Button
          style={{
            backgroundColor: '#ED1A3D',
            color: 'white',
            height: '40px',
            borderRadius: '10px',
            border: 'none',
            cursor: 'pointer',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '10px 20px'
          }}
          onClick={onHide}
        >
          CANCEL
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmResendModal;